import { useCurrentModule } from '../components';
import { isMobileStickyPlanAndCycleEnabled } from '../utils/isMobileStickyPlanAndCycleEnabled';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useSwitchFlows } from './useSwitchFlows';

/**
 * Mobile rolls out on its own spec; desktop is always on, so either surface
 * can move alone.
 */
export const AI_REC_PREMIUM_PLAN_MOBILE_SPEC = 'aiRecPremiumPlanMobile';
export const AI_REC_BANNER_SPEC = 'eclipseAiRec';
export const useAiRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const isMobile = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME;
  const isLoading = ready === false || isSwitchFlowLoading;
  const isEligible = !isLoading && isSwitchFlow === false;
  if (isMobile) {
    const isSpecOn = ready !== false && (isMobileStickyPlanAndCycleEnabled({
      experiments,
      isMobile
    }) || experiments.isEnabled(AI_REC_PREMIUM_PLAN_MOBILE_SPEC));
    return {
      isEnabled: isSpecOn && isEligible,
      isLoading: ready === false || isSpecOn && isSwitchFlowLoading,
      isBannerVariant: false,
      showsGeneratedContent: false
    };
  }
  return {
    isEnabled: isEligible,
    isLoading,
    isBannerVariant: isEligible && experiments.isEnabled(AI_REC_BANNER_SPEC),
    showsGeneratedContent: false
  };
};
//# sourceMappingURL=useAiRecommendationEnabled.js.map